(function(){
  
  
  function handleResize() {
    if (window.innerWidth > 992) {
      var poster = document.querySelector('.media.deferred-media__poster');
      var textOver = document.querySelector('.video--text-over');
  
      poster.addEventListener('click', function() {
        textOver.style.display = 'none';
      });
    } else {
      var poster = document.querySelector('.media.deferred-media__poster');
      poster.removeEventListener('click', function() {
        textOver.style.display = 'none';
      });
    }
  }
  
  // Initial check on page load
  handleResize();
  
  // Add a resize event listener
  window.addEventListener('resize', handleResize);

  

})();